import WrapperLoading from "components/WrapperLoading";
import ReportDetailContent from "components/report/ReportDetailContent/ReportDetailContent";
import { RevisionDto } from "interfaces/revision";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { revisionService } from "services/revisionService";

export default function ReportRevisionPage() {
  const params = useParams();
  const [revision, setRevision] = useState<RevisionDto>();

  useEffect(() => {
    if (params.id) {
      (async () => {
        const revision = await revisionService.getById(params.id as string);

        setRevision(revision);
      })();
    }
  }, [params.id]);

  return revision ? (
    <ReportDetailContent revisionMode reportDto={revision.data} />
  ) : (
    <WrapperLoading />
  );
}
